import { SET_DRUG_LABEL_LIST } from '../constants/DrugLabel';

const initState = {
  drugLabelList: []
};

const drugLabel = (state = initState, action) => {
  switch (action.type) {
    case SET_DRUG_LABEL_LIST:
      return {
        ...state,
        drugLabelList: action.drugLabelList
      };
    default:
      return state;
  }
};

export default drugLabel;
